/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';

/**
 * 
 * @export
 * @interface EListSearchTypeDoubleCombinableCriteria
 */
export interface EListSearchTypeDoubleCombinableCriteria {
    /**
     * 
     * @type {EListSearchType}
     * @memberof EListSearchTypeDoubleCombinableCriteria
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {number}
     * @memberof EListSearchTypeDoubleCombinableCriteria
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof EListSearchTypeDoubleCombinableCriteria
     */
    secondaryValue?: number;
}

/**
 * Check if a given object implements the EListSearchTypeDoubleCombinableCriteria interface.
 */
export function instanceOfEListSearchTypeDoubleCombinableCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EListSearchTypeDoubleCombinableCriteriaFromJSON(json: any): EListSearchTypeDoubleCombinableCriteria {
    return EListSearchTypeDoubleCombinableCriteriaFromJSONTyped(json, false);
}

export function EListSearchTypeDoubleCombinableCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EListSearchTypeDoubleCombinableCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : json['secondaryValue'],
    };
}

export function EListSearchTypeDoubleCombinableCriteriaToJSON(value?: EListSearchTypeDoubleCombinableCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': value.value,
        'secondaryValue': value.secondaryValue,
    };
}

